<template>  
  <div class="page-title">
    <div class="container">
      <div class="page-caption">
        <h2>{{ title }}</h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Banner',
  props: ['title']
}
</script>
